import styled from 'styled-components';
import {typographyStyles} from '../../utils/styles';

export const StyledConfidenceCircle = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${({bg}) => bg};
  flex-shrink: 0;
  cursor: unset;
`;

export const StyledConfidenceTag = styled.span`
  ${typographyStyles.footnote.medium};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  height: 16px;
  color: ${({color}) => color};
  background: ${({bg}) => bg};
  margin-top: 3px;
  padding: 0 6px;
`;

export const StyledConfidenceTooltipContent = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_2};
  align-items: self-start;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
